import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_DROPDOWN_MENU_ITEMS_LIST } from "../../actions/types";
import { SaleReportService, CoreService } from "../../services";
import { ConfirmDialog } from "../../components/shared";
import SuccessDialog from '../../components/shared/SuccessDialog';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { Backdrop, Box, Button, Card, CardContent, CircularProgress, Container, Grid, IconButton, LinearProgress, Paper, TextField, Tooltip, useMediaQuery } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
//import { DataGrid} from '@material-ui/data-grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ArrowExpandHorizontal, ArrowCollapseHorizontal } from "mdi-material-ui";
import MaterialTable, { MTableToolbar, MTableHeader } from 'material-table'
import TableIcons from '../../materialTableIcons';
import '../GridStyleOverrides/materialTableHome.css'
import { red, green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
    gridActionsContainer: {
        display: 'flex',
        width: '100%',
        height: 32,
        alignItems: 'center',
        justifyContent: 'flex-end',
        backgroundColor: theme.palette.background.paper,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4
    },
    materialReceivingTable: {
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .material-receiving-table.error': {
            backgroundColor: red[100],
            color: red[600],
        },
        '& .material-receiving-table.success': {
            backgroundColor: green[100],
            color: green[600],
        },
        '& .material-receiving-table--header': {
            backgroundColor: '#86C1D4',
            color: 'white',
            fontWeight: 'bold',
        },
        '& svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator': {
            display: 'none'
        }

    },
    table: {
        backgroundColor: theme.palette.background.paper,

    },
    addMaterialReceiving: {
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
}));

export default function SaleReportHome() {

    //styles
    const classes = useStyles();
    const theme = useTheme()
    const headerStyle = {
        backgroundColor: '#86C1D4',
        height: 40,
        textTransform: 'uppercase',
        color: 'white',
        paddingTop: 0,
        paddingBottom: 0,
    }
    const godRowStyle = {
        paddingTop: 0,
        paddingBottom: 0,
        height: 40,
    }
    const parentRowStyle = {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[700],
        paddingTop: 0,
        paddingBottom: 0,
        height: 32
    }
    const childRowStyle = {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[600],
        paddingTop: 0,
        paddingBottom: 0,
        height: 24,
        maxHeight: 24,
        minHeight: 24
    }

    const dispatch = useDispatch();
    const dropdownItemsStore = useSelector((state) => state.dropdownMenuItems);

    const tableRef = useRef();

    // Loading
    const [isLoading, setIsLoading] = useState(true);
    const [isTableLoading, setIsTableLoading] = useState(false);
    // Dialogs
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [successDialog, setSuccessDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    // Menu Item Dropdown
    const [searchFormData, setSearchFormData] = useState({
        transactionType: 'Sale',
        startDate: null,
        endDate: null,
        plant: '',
        storage: '',
        materialNo: '',
        shipToName: ''
    })
    const [searchAutocompleteData, setSearchAutocompleteData] = useState({
        plant: { text: "", value: "" },
        storage: { text: "", value: "" },
        materialNo: { text: "", value: "" },
        shipToName: { text: "", value: "" }
    })
    const [dropdownStorageLocation, setDropdownStorageLocation] = useState([{ text: "Select a Plant first", value: "" }]);
    // Table
    const [visibilityTable, setVisibilityTable] = useState("hidden")
    const [tableParameters, setTableParameters] = useState({
        dataGridParameters: { "page": 0, "pageSize": 20 }, dataGridSort: {}
    })

    //handle Expand/Collapse Grid
    const isLargeDisplay = useMediaQuery('(min-width: 1500px)');
    //use this to change container props. setting to {maxWidth: false} allows grid to expand full width
    const [containerProps, setContainerProps] = useState('');
    //Grid Actions toolip
    const [openTooltip, setOpenTooltip] = useState(false)
    const handleShowTooltip = () => {
        setOpenTooltip(true)
    }
    const handleHideTooltip = () => {
        setOpenTooltip(false)
    }


    const [fetchItem, setfetchItem] = useState({ salesList: [] });
    const [page, setPage] = React.useState(0);

    useEffect(() => {
        /* Retreive dropdown if they are not already in the Redux store*/
        let dropdownToGet = ['sapPlant', 'sapMaterial', 'sapStorageLocation', 'sapCustomers']
        if (dropdownItemsStore) {
            for (var i = 0; i < dropdownToGet.length; i++) {
                if (dropdownItemsStore[dropdownToGet[i]].length !== 0) {
                    dropdownToGet = dropdownToGet.filter(function (item) {
                        return item !== dropdownToGet[i];
                    })
                }
            }
        }
        CoreService.dropdownItems(dropdownToGet).then(
            (response) => {
                if (response) {
                    const data = response.data;
                    dispatch({
                        type: SET_DROPDOWN_MENU_ITEMS_LIST,
                        payload: data,
                    });
                }
                setIsLoading(false);
            });
    }, [dispatch]);

    async function fetchTableDataWithFilter(filters) {
        //console.log(filters);
        setfetchItem({ salesList: [] })
        SaleReportService.searchSaleData(filters).then(
            (response) => {
                if (response && response.data?.salesList) {
                    let all = response.data.salesList;
                    let masterArr = []
                    for (let i = 0; i < all.length; i++) {
                        masterArr[i] = {
                            masterId: all[i].transaction.ticketId + '-' + all[i].transaction.doNo + '-master',
                            isMaster: true,
                            filterStartDate: searchFormData.startDate,
                            filterEndDate: searchFormData.endDate,
                            ticketId: all[i].transaction.ticketId,
                            loadingDate: all[i].transaction.loadingDate,
                            soNo: all[i].sapDo[0].soNo,
                            shipToName: all[i].sapDo[0].shipToName,
                            doNo: all[i].transaction.doNo,
                            transportCom: all[i].transaction.transportCom,
                            truckNo: all[0].transaction.truckNo,
                            driver: all[i].transaction.driver,
                            container: all[i].transaction.container,
                            sealNo: all[i].transaction.sealNo,
                            weightInDatetime: all[i].transaction.weightInDatetime,
                            weightIn: all[i].transaction.weightIn,
                            weightOutDatetime: all[i].transaction.weightOutDatetime,
                            weightOut: all[i].transaction.weightOut,
                            doInsTxt: all[i].transaction.doInsTxt,
                        }
                    }
                    let addSubItemsWithParentIds = [];
                    for (let i = 0; i < all.length; i++) {
                        let doItems = all[i].doItems
                        let withParents = []
                        for (let x = 0; x < doItems.length; x++) {
                            let mat;
                            try {
                                mat = dropdownItemsStore['sapMaterial'].find(y => y.value === doItems[x].materialNo).text.split(':')[1].trimStart();
                            } catch (e) {
                                mat = "";
                            }
                            //if (doItems[x].higherLevelItem === '000000') {
                            //    withParents[x] = {
                            //        doItem: doItems[x].doItem,
                            //        plantFrom: doItems[x].plantFrom,
                            //        materialNo: doItems[x].materialNo,
                            //        materialName: mat,
                            //        slocFrom: doItems[x].slocFrom,
                            //        batchNoFrom: doItems[x].batchNoFrom,
                            //        grossWeight: doItems[x].grossWeight,
                            //        netWeight: doItems[x].netWeight,
                            //        weightUnit: doItems[x].weightUnit,
                            //        pickQtySu: doItems[x].pickQtySu,
                            //        salesUnit: doItems[x].salesUnit,
                            //        higherLevelItem: doItems[x].higherLevelItem,
                            //        //masterId: all[i].transaction.ticketId + '-' + all[i].transaction.doNo + '-parent',
                            //        masterId: false,
                            //        isMaster: false,
                            //        parentId: all[i].transaction.ticketId + '-' + all[i].transaction.doNo + '-master'
                            //    }
                            //} else if (Number(doItems[x].higherLevelItem) > 0) {
                            //    withParents[x] = {
                            //        doItem: doItems[x].doItem,
                            //        plantFrom: doItems[x].plantFrom,
                            //        materialNo: doItems[x].materialNo,
                            //        materialName: mat,
                            //        slocFrom: doItems[x].slocFrom,
                            //        batchNoFrom: doItems[x].batchNoFrom,
                            //        grossWeight: doItems[x].grossWeight,
                            //        netWeight: doItems[x].netWeight,
                            //        weightUnit: doItems[x].weightUnit,
                            //        pickQtySu: doItems[x].pickQtySu,
                            //        salesUnit: doItems[x].salesUnit,
                            //        higherLevelItem: doItems[x].higherLevelItem,
                            //        //masterId: all[i].transaction.ticketId + '-' + all[i].transaction.doNo + '-' + doItems[x].doItem + '-' + doItems[x].higherLevelItem,
                            //        masterId: false,
                            //        isMaster: false,
                            //        parentId: all[i].transaction.ticketId + '-' + all[i].transaction.doNo + '-master'
                            //    }
                            //}
                            withParents[x] = {
                                    doItem: doItems[x].doItem,
                                    plantFrom: doItems[x].plantFrom,
                                    materialNo: doItems[x].materialNo,
                                    materialName: mat,
                                    slocFrom: doItems[x].slocFrom,
                                    batchNoFrom: doItems[x].batchNoFrom,
                                    grossWeight: doItems[x].grossWeight,
                                    netWeight: doItems[x].netWeight,
                                    weightUnit: doItems[x].weightUnit,
                                    pickQtySu: doItems[x].pickQtySu,
                                    salesUnit: doItems[x].salesUnit,
                                    higherLevelItem: doItems[x].higherLevelItem,
                                    //masterId: all[i].transaction.ticketId + '-' + all[i].transaction.doNo + '-' + doItems[x].doItem + '-' + doItems[x].higherLevelItem,
                                    masterId: false,
                                    isMaster: false,
                                    parentId: all[i].transaction.ticketId + '-' + all[i].transaction.doNo + '-master'
                                }
                        }
                        addSubItemsWithParentIds[i] = withParents.flat()
                    }
                    let flattened = addSubItemsWithParentIds.flat();
                    setfetchItem({ salesList: [...masterArr, ...flattened] });
                }
                setIsTableLoading(false);
            });
    };

    const handleSearchSubmit = (search) => {
        setVisibilityTable("visible");
        setIsTableLoading(true);
        fetchTableDataWithFilter({
            ...searchFormData,
            'dataGridSort': { field: '', sort: '' },
            'dataGridParameters': {}
        });
    };
    const handleSearchFormChange = (target, fieldName) => {
        var value = target !== null ? target.value : ''
        var text = target !== null ? target.text : ''
        if (fieldName === 'plant') {
            var newStorageLocationList = dropdownItemsStore["sapStorageLocation"].filter(function (location) {
                return location.plant === value;
            });
            setDropdownStorageLocation(newStorageLocationList);
            setSearchAutocompleteData({
                ...searchAutocompleteData,
                plant: { text, value },
                storage: { text: '', value: '' }
            });
            setSearchFormData({
                ...searchFormData,
                plant: value,
                storage: ''
            });
        }
        else {
            setSearchAutocompleteData({ ...searchAutocompleteData, [fieldName]: { text: text, value: value } })
            setSearchFormData({ ...searchFormData, [fieldName]: value });
        }
    };
    const handleSearchStartDateChange = (date) => {
        setSearchFormData({ ...searchFormData, ...tableParameters, startDate: date });
    };
    const handleSearchEndDateChange = (date) => {
        setSearchFormData({ ...searchFormData, ...tableParameters, endDate: date });
    };
    //const handlePageSizeTransactionsTable = (event) => {
    //    fetchTableDataWithFilter({
    //        ...searchFormData,
    //        ...tableParameters, 'dataGridParameters': event
    //    });
    //};
    //const handlePageChangeTransactionsTable = (event) => {
    //    setTableParameters({
    //        ...tableParameters,
    //        'dataGridParameters': event
    //    })
    //    fetchTableDataWithFilter({
    //        ...searchFormData,
    //        ...tableParameters, 'dataGridParameters': event
    //    });
    //};
    //const handleSortTransactionsTable = (event) => {
    //    setTableParameters({
    //        ...tableParameters, 'dataGridSort': event.sortModel[0]
    //    })
    //    if (event.sortModel[0]) {
    //        fetchTableDataWithFilter({
    //            ...searchFormData,
    //            ...tableParameters, 'dataGridSort': { field: event.sortModel[0].field, sort: event.sortModel[0].sort }
    //        });
    //    }
    //    else {
    //        fetchTableDataWithFilter({
    //            ...searchFormData,
    //            ...tableParameters, 'dataGridSort': { field: '', sort: '' }
    //        });
    //    }
    //};

    const handleExportExcel = async () => {
        let tData = [...tableRef.current.dataManager?.data?.filter(x => x.isMaster === true)]
        if (tData.length === 0) {
            return alert("There is no data to export")
        }
        let res = await SaleReportService.generateExcel(tData);
        console.log(res)
    }
    const rows = fetchItem ? fetchItem.salesList : [];


    const columns = [
        {
            field: 'ticketId',
            title: 'Ticket Id',
            width: 180,
        },
        {
            field: 'loadingDate',
            title: 'LOADING DATE',
            render: (rowData) => rowData.loadingDate ? (new Date(rowData.loadingDate)).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) : null
        },
        {
            field: 'soNo',
            title: 'SO',
            width: 110,
        },
        {
            field: 'shipToName',
            title: 'Customer',
        },
        {
            field: 'doNo',
            title: 'DO',
            width: 110,
        },
        {
            field: 'doItem',
            title: 'Do Item',
            width: 110,
        },
        {
            field: 'higherLevelItem',
            title: 'HL Item',
            width: 110,
        },
        {
            field: 'plantFrom',
            title: 'PLANT',
            width: 110,
        },
        {
            field: 'materialNo',
            title: 'Mat No',
            width: 110,
        },
        {
            field: 'materialName',
            title: 'Mat Name',
            //render: rowData => {
            //    let mat;
            //    try {
            //       mat = dropdownItemsStore['sapMaterial'].find(y => y.value === rowData.materialNo).text.split(':')[1].trimStart();
            //    } catch (e) {
            //        mat = "";
            //    }
            //    return mat;
            //}, 
        },
        {
            field: 'slocFrom',
            title: 'Sloc',
            width: 100,
        },
        {
            field: 'batchNoFrom',
            title: 'Batch',
            width: 100,
        },
        {
            field: 'grossWeight',
            title: 'Gross Weight',
            width: 130,
        },
        {
            field: 'netWeight',
            title: 'Net Weight',
            width: 130,
        },
        {
            field: 'weightUnit',
            title: 'Weight Unit',
            width: 130,
        },
        {
            field: 'pickQtySu',
            title: 'Pick Qty',
            width: 110,
        },
        {
            field: 'salesUnit',
            title: 'Sales Unit',
            width: 140,
        },
        {
            field: 'transportCom',
            title: 'Truck Company',
            width: 110,
        },
        {
            field: 'truckNo',
            title: 'Truck No',
            width: 110,
        },
        {
            field: 'driver',
            title: 'Driver',
            width: 110,
        },
        {
            field: 'container',
            title: 'Container Id',
            width: 110,
        },
        {
            field: 'sealNo',
            title: 'Seal No',
            width: 110,
        },
        {
            field: 'weightInDatetime',
            title: 'Weight In Date',
            width: 110,
            sortable: false,
            render: (rowData) => rowData.weightInDatetime ? (new Date(rowData.weightInDatetime)).toLocaleString('en-GB') : null
        },
        {
            field: 'weightIn',
            title: 'Weight In',
            width: 110,
        },
        {
            field: 'weightOutDatetime',
            title: 'Weight Out Date',
            width: 110,
            sortable: false,
            render: (rowData) => rowData.weightOutDatetime ? (new Date(rowData.weightOutDatetime)).toLocaleString('en-GB') : null
        },
        {
            field: 'weightOut',
            title: 'Weight Out',
            width: 110,
        },
        {
            field: 'doInsTxt',
            title: 'Remark',
            width: 110,
        }
    ];
    return (
        <>
            <Container id='containerMR'{...containerProps}>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Sale Report
                    </h2>
                </div>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Card className={classes.root}>
                        <CardContent>
                            <form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={10} lg={10}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <Grid container justify="space-around">
                                                        <KeyboardDatePicker
                                                            disableToolbar
                                                            autoOk={true}
                                                            size="small"
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="dd-MMM-yyyy"
                                                            id="startDate"
                                                            label="Start Date"
                                                            value={searchFormData.startDate}
                                                            onChange={handleSearchStartDateChange}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                        />
                                                    </Grid>
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <Grid container justify="space-around">
                                                        <KeyboardDatePicker
                                                            disableToolbar
                                                            autoOk={true}
                                                            size="small"
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="dd-MMM-yyyy"
                                                            id="endDate"
                                                            label="End Date"
                                                            value={searchFormData.endDate}
                                                            onChange={handleSearchEndDateChange}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                        />
                                                    </Grid>
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchPlantList"
                                                    name="searchPlantList"
                                                    options={dropdownItemsStore["sapPlant"]}
                                                    value={{ text: searchAutocompleteData.plant.text, value: searchAutocompleteData.plant.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'plant');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchPlantList"
                                                        name="searchPlantList"
                                                        label="Plant"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchStorageList"
                                                    name="searchStorageList"
                                                    options={dropdownStorageLocation}
                                                    value={{ text: searchAutocompleteData.storage.text, value: searchAutocompleteData.storage.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    getOptionSelected={(option, value) => option.text === value.text}
                                                    getOptionDisabled={(option) => option.value === ""}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'storage');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchStorageList"
                                                        name="searchStorageList"
                                                        label="Storage"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchMaterialList"
                                                    name="searchMaterialList"
                                                    options={dropdownItemsStore["sapMaterial"]}
                                                    value={{ text: searchAutocompleteData.materialNo.text, value: searchAutocompleteData.materialNo.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    getOptionSelected={(option, value) => option.text === value.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'materialNo');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchMaterialList"
                                                        name="searchMaterialList"
                                                        label="Material"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchCustomerList"
                                                    name="searchCustomerList"
                                                    options={dropdownItemsStore['sapCustomers']}
                                                    value={{ text: searchAutocompleteData.shipToName.text, value: searchAutocompleteData.shipToName.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    getOptionSelected={(option, value) => option.text === value.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'shipToName');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchCustomerList"
                                                        name="searchCustomerList"
                                                        label="Customer"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <Grid container spacing={1} style={{ textAlign: "center" }}>
                                            <Grid item xs={12}>
                                                <Button style={{ width: '100%' }} variant="contained" onClick={handleSearchSubmit}>Search</Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button style={{ width: '100%' }} color="primary" variant="contained" onClick={handleExportExcel}>Export</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {isLargeDisplay && visibilityTable === 'visible' ?
                        <div className={classes.gridActionsContainer}>
                            <Tooltip
                                title={!containerProps ? 'Expand' : 'Collapse'}
                                open={openTooltip}
                                placement='top'
                            >
                                <IconButton
                                    onMouseEnter={handleShowTooltip}
                                    onMouseLeave={handleHideTooltip}
                                    onClick={() => {
                                        if (!containerProps) {
                                            setContainerProps({ maxWidth: false })
                                        } else {
                                            setContainerProps('')
                                        }
                                        handleHideTooltip()
                                    }
                                    }>
                                    {!containerProps ?
                                        <ArrowExpandHorizontal />
                                        :
                                        <ArrowCollapseHorizontal />
                                    }
                                </IconButton>
                            </Tooltip>
                        </div>
                        :
                        null
                    }

                    <Box px={1.5} visibility={visibilityTable} className={classes.materialReceivingTable}>
                        <div style={{ height: 600, width: "100%" }}>
                            <MaterialTable
                                style={{ width: '100%' }}
                                tableRef={tableRef}
                                title=""
                                icons={TableIcons}
                                isLoading={isTableLoading}
                                components={{
                                    Toolbar: props => (
                                        <div style={{ width: 0, height: 0 }}>
                                            <MTableToolbar {...props} />
                                        </div>
                                    ),
                                    Header: props => (
                                        <>
                                            <MTableHeader {...props} />
                                        </>
                                    ),
                                }}
                                data={rows}
                                columns={columns}
                                parentChildData={(row, rows) => rows.find(a => {
                                    return a.masterId === row.parentId
                                })
                                }
                                options={{
                                    actionsCellStyle: { paddingLeft: 0, paddingRight: 10 },
                                    headerStyle: headerStyle,
                                    rowStyle: rowData => {
                                        if (rowData.masterId) {
                                            return godRowStyle;
                                        } else {
                                            return childRowStyle;
                                        }
                                    },
                                    cellStyle: { paddingTop: 0, paddingBottom: 0},
                                    maxBodyHeight: 530,
                                    showTitle: false,
                                    toolbar: false,
                                    paging: true,
                                    pageSize: 10,
                                }}
                            />
                        </div>
                    </Box>
                </Grid>
            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <SuccessDialog
                successDialog={successDialog}
                setSuccessDialog={setSuccessDialog}
            />
            <Backdrop className={classes.backdrop} open={isLoading} timeout={{ enter: 1100 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}
